import { AnsweringClient } from "../clients/answeringClient";

export interface AnonControllerDelegate {
  inviteSuccess(access: string, refresh: string): void;
  inviteFailed(): void;
  setRedirectingText(value: string | null): void;
  authenticationFailed(): void;
}

export class AnonController {
  constructor(
    private delegate: AnonControllerDelegate,
    private client = new AnsweringClient()
  ){}

  public async registerInvite(token: string) {
    this.delegate.setRedirectingText("Atualizando dados...");

    try {
      const result = await this.client.authAnon(token);
      const { accessToken, refreshToken } = result.data
      if (Math.trunc(result.status/100) !== 2)
        return this.delegate.inviteFailed();

      this.delegate.inviteSuccess(accessToken, refreshToken);
    } catch (error) {
      this.delegate.inviteFailed();
    }
  }
}
